const FIREBASE_AUTH_ERROR_MESSAGES: Record<string, string> = {
  'auth/invalid-verification-code':
    'The verification code is incorrect. Please try again.',
  'auth/code-expired':
    'The verification code has expired. Please request a new one.',
  'auth/missing-phone-number': 'Please enter a valid phone number.',
  'auth/quota-exceeded': 'Too many requests. Please try again later.',
  'auth/captcha-check-failed':
    'Security verification failed. Please try again.',
  'auth/maximum-second-factor-count-exceeded': `You've reached the maximum number of verification methods.`,
  'auth/second-factor-already-in-use':
    'This verification method is already set up.',
  'auth/unverified-email':
    'Please verify your email address before setting up two-factor authentication.',
  'auth/requires-recent-login':
    'For security, please sign out and sign in again before making this change.',
  'auth/invalid-phone-number':
    'The phone number format is invalid. Use international format (e.g., +61412345678).',
  'auth/too-many-requests':
    'Too many attempts. Please wait a moment and try again.',
  'auth/user-token-expired': 'Your session has expired. Please sign in again.',
  'auth/network-request-failed':
    'Network error. Please check your connection and try again.',
};

const FALLBACK_AUTH_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export function getAuthErrorMessage(error: unknown): string {
  const code = extractFirebaseErrorCode(error);
  if (code && FIREBASE_AUTH_ERROR_MESSAGES[code]) {
    return FIREBASE_AUTH_ERROR_MESSAGES[code];
  }
  return FALLBACK_AUTH_ERROR_MESSAGE;
}

function extractFirebaseErrorCode(error: unknown): string | undefined {
  if (error && typeof error === 'object' && 'code' in error) {
    const code = (error as { code: unknown }).code;
    return typeof code === 'string' ? code : undefined;
  }
  return undefined;
}
